import { memo } from 'react';
// Local files
import Item from './Item/Item';
import BaseAnalysesList from 'components/Analyses/Common/BaseAnalysesList/BaseAnalysesList';
import ErrorWrapper from 'components/Common/ErrorWrapper/ErrorWrapper';
import useCustomSelector from 'hooks/useCustomSelector';
import useEsignAnalyses from 'hooks/useEsignAnalyses';
import { esignAnalysesSelectors } from 'features/esignAnalyses';

const EsignAnalysesList = () => {
  const { getEsignAnalyses } = useEsignAnalyses();
  const { data, pagination } = useCustomSelector(esignAnalysesSelectors.getEsignAnalysesData);
  const fetching = useCustomSelector(esignAnalysesSelectors.esignAnalysesIsFetching);

  return (
    <BaseAnalysesList
      fetchData={getEsignAnalyses}
      getData={data}
      isFetching={fetching}
      pagination={pagination}
      renderItem={(item) => <Item key={item.id} {...item} />}
    />
  );
};

const WrappedComponent = props => {
  return (
    <ErrorWrapper>
      <EsignAnalysesList {...props} />
    </ErrorWrapper>
  );
};

export default memo(WrappedComponent);